// Product cards and the header remain eagerly registered. Load the other
// components only when their markup exists, including cart/quick-add updates.
const modules = [
  { selector: 'variant-picker', load: () => import('@theme/variant-picker') },
  { selector: 'swatches-variant-picker-component', load: () => import('@theme/swatches-variant-picker') },
  { selector: 'product-form-component, add-to-cart-component', load: () => Promise.all([
    import('@theme/product-form'), import('@theme/fly-to-cart'),
  ]) },
  { selector: 'product-price', load: () => import('@theme/product-price') },
  { selector: 'product-sku-component', load: () => import('@theme/product-sku') },
  { selector: 'product-inventory', load: () => import('@theme/product-inventory') },
  { selector: 'quantity-selector-component', load: () => import('@theme/component-quantity-selector') },
  { selector: 'media-gallery', load: () => import('@theme/media-gallery') },
  { selector: 'deferred-media, product-model', load: () => import('@theme/media') },
  { selector: 'video-background-component', load: () => import('@theme/video-background') },
  { selector: 'volume-pricing', load: () => import('@theme/volume-pricing') },
  { selector: 'price-per-item', load: () => import('@theme/price-per-item') },
  { selector: 'volume-pricing-info', load: () => import('@theme/volume-pricing-info') },
];

const pending = new Set(modules);
const byTag = new Map();
for (const component of modules) {
  for (const tag of component.selector.split(', ')) byTag.set(tag, component);
}
const selector = [...byTag.keys()].join(', ');

function load(element) {
  const component = byTag.get(element.localName);
  if (!component || !pending.has(component)) return;
  pending.delete(component);
  component.load().catch((error) => {
    // A later section insertion can retry a transient loading failure.
    pending.add(component);
    console.error('Unable to load a theme component', error);
  });
}

function scan(root) {
  if (!pending.size) return;
  if (root.nodeType === Node.ELEMENT_NODE) load(root);
  // One query per subtree, rather than a traversal for every unused component.
  root.querySelectorAll?.(selector).forEach(load);
}

scan(document);
new MutationObserver((mutations) => {
  if (!pending.size) return;
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === Node.ELEMENT_NODE) scan(node);
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true });
